<template>
  <div>
    <canvas ref="chartRef"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Chart from 'chart.js/auto'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({
      labels: ['Completed', 'Missed', 'In Progress'],
      datasets: [{
        data: [45, 5, 2],
        backgroundColor: ['rgb(34, 197, 94)', 'rgb(239, 68, 68)', 'rgb(251, 191, 36)']
      }]
    })
  }
})

const chartRef = ref(null)

onMounted(() => {
  new Chart(chartRef.value, {
    type: 'doughnut',
    data: props.data,
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  })
})
</script>